import {
  GET_PROJECT_BUDGETS, CREATE_PROJECT_BUDGET,
  UPDATE_PROJECT_BUDGET, DELETE_PROJECT_BUDGET
} from '../actions/projectBudgetActions';

const initialState = { budgets: [], numberOfPages: 1, isLoading: false };

const projectBudget = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROJECT_BUDGETS:
      return { ...state, budgets: action.payload.budgets, numberOfPages: action.payload.totalPages };
    case CREATE_PROJECT_BUDGET:
      return { ...state, budgets: [action.payload, ...state.budgets] };
    case UPDATE_PROJECT_BUDGET:
      return { ...state, budgets: state.budgets.map(b => b._id === action.payload._id ? action.payload : b) };
    case DELETE_PROJECT_BUDGET:
      return { ...state, budgets: state.budgets.filter(b => b._id !== action.payload) };
    default:
      return state;
  }
};

export default projectBudget;
